import {mapGetters} from 'vuex';

export default {
    name: 'course-video-trailer',
    data() {
        return {
            isReady: false,
        }
    },
    computed: {
        ...mapGetters({
            currentItem: 'courses/currentItem',
        }),
    },
    mounted() {
        if (this.currentItem.trailerProvider === 'youtube') {
        }
    },
    methods: {
        onPlay() {
            if (this.currentItem.trailerProvider === 'youtube') {

            } else {

            }
        },
    }
}
